import styles from "./Header.module.scss";
import { OverlayContext } from "../../../context/OverlayContext";
import { useContext } from "react";
import { Link } from 'react-router-dom';
import { UserContext } from '../../../context/UserContext';
import DefaultImage from "../../../styles/logo-bom.png"

type HeaderProps = {
  title?: string;
  subtitle: string;
  role?: string;
};

export const Header = ({ title, subtitle }: HeaderProps) => {
  const { setOverlay } = useContext(OverlayContext);
  const userContext = useContext(UserContext)


  return (
    <>
      <header className={styles.header}>
        <div className={styles.leftSide}>
          <button className={styles.burger} onClick={() => setOverlay(true)}>
            <img
              src='/assets/burger.svg'
              width='30'
              height='30'
              alt='bugerIcon'
            />
          </button>
          <div className={styles.title}>
            <span className={styles.asH1}>{subtitle}</span>
            <span className={styles.asH2}> {title}</span>
          </div>
        </div>
        <div className={styles.buttons}>
          {(userContext.organisation?.name === 'BOM' || userContext.organisation?.parent?.name === 'BOM') &&
            <img className={styles.image} src={DefaultImage}/>
            || <img className={styles.image} src={userContext.organisation?.logoUrl}/>
          }
          <Link to='/logout'>
            <button className={styles.logoutNav}>
              <img src='/assets/logout.svg' alt='logout' />
            </button>
          </Link>
          {/*{isAdmin && <ToggleAdmin />}*/}
          <Link to='/account'>
            <button className={styles.profile}>
              <img src='/assets/user.svg' alt='user' />
            </button>
          </Link>
        </div>
      </header>
      <header className={styles.headerMobile}>
        <div className={styles.top}>
          <button
            className={styles.burgerMobile}
            onClick={() => setOverlay(true)}
          >
            <img
              src='/assets/burger.svg'
              width='30'
              height='30'
              alt='bugerIcon'
            />
          </button>
          <div className={styles.buttonsMobile}>
            {/*{isAdmin && <ToggleAdmin />}*/}
            {(userContext.organisation?.name === 'BOM' || userContext.organisation?.parent?.name === 'BOM') &&
                <img className={styles.image} src={DefaultImage}/>
                || <img className={styles.image} src={userContext.organisation?.logoUrl}/>
            }
            <Link to='/logout'>
              <button className={styles.logoutNav}>
                <img src='/assets/logout.svg' alt='logout' />
              </button>
            </Link>
            <Link to='/account'>
              <button className={styles.profile}>
                <img src='/assets/user.svg' alt='user' />
              </button>
            </Link>
          </div>
        </div>
        <h1 className={styles.title}>
          {title}
          <br />
          <span className={styles.asH1}>{subtitle}</span>
        </h1>
      </header>
    </>
  );
};
